export default {
  head: state => state.head,
  header: state => state.header,
  clientContext: state => state.clientContext,
  megaMenu: state => state.megaMenu,
  footer: state => state.footer
};
